const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  areaId: state => state.user.areaId,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  btnpers: state => state.permission.btnpers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js